import React from 'react'
import './stats.scss';

function Stats({ data }) {
  let charLen = -1;
  function checkStringValues(inputString) {
    if (inputString.includes('pt')) {
      charLen = -2;
    } else if (inputString.includes('hrs')) {
      charLen = -3;
    }
    else if (inputString.includes('3-7 yrs')) {
      charLen = 4;
    }
    else {
      charLen = -1;
    }
  }

  const positionLeft = (item) => (item?.title).trim().charAt(0) === "$";
  return (
    <div className='stats-flex-container'>
      {
        data && Array.isArray(data) && data.map((item) => {

          checkStringValues(item.title.trim());
          return (
            <div className='stats-flex-column' key={item.title}>
              <div className='stats-title'>
                {positionLeft(item) ?
                  (<>
                    <span className={`${isNaN(item?.title) ? 'energy-purple' : ''}`}>
                      {(item?.title).trim().charAt(0)}
                    </span>
                    {(item?.title).trim().slice(1)}
                  </>) :
                  (<>
                    {(item?.title).trim().slice(0, charLen) || ""}
                    <span className={`${isNaN(item?.title) ? 'energy-purple' : ''}`}>
                      {(item?.title).trim().slice(charLen)}
                    </span>
                  </>)
                }
              </div>
              <p className='stats-text' dangerouslySetInnerHTML={{ __html: item?.remark || "" }}></p>
            </div>
          );
        })
      }
    </div>
  )
}

export default React.memo(Stats);